import { debounce } from 'lodash'
import { default as initSB } from './sb'
import { init as initMenus } from './menus'
import { init as initLayout } from './components/layout'
import { init as initSliders } from './components/sliders'
import { init as initSearch } from './components/search'
import Cookies from 'js-cookie'
import { isNarrowDevice } from "./sb/mediaQueries";

const $ = window.jQuery

const initAnchors = () => {
  const preHome = $('#pre-home')

  if (isNarrowDevice()) {

    new SmoothScroll('a[href^="#"]:not([href="#"])', {
      speed: 600,
      emitEvents: true
    });

    window.addEventListener('scroll', debounce(() => {
      if (window.scrollY > preHome.height()) {
        Cookies.set('preHomeShown', 1, {expires: 1})
      }
    }, 50), false)
    return
  }

  preHome.css('height', $(window).height())

  $.scrollify({
    section: '.scroll-section',
    offset: 0.5,
    scrollbars: true,
    setHeights: false,
    overflowScroll: true,
    updateHash: false,
    touchScroll: true,
    after: function (index, sections) {
      switch (index) {
        case 0:
          break;
        case 1:
          Cookies.set('preHomeShown', 1, {expires: 1})
          break;
      }
    }
  })




  $('#js-preHomeScroll').on('touchstart click', function (e) {
    e.preventDefault()
    $.scrollify.move(1)
  })
}

$(document).ready(function () {
  const body = $('body')
  initSB()
  initMenus()

  initLayout()
  initSliders()

  if (body.hasClass('frontpage')) {
    initAnchors()
  }
  else {
    initSearch()
  }
})



//////////////////
// WEBPACK FOOTER
// ./src/js/index.js
// module id = 5
// module chunks = 0